module.exports = __webpack_public_path__ + "img/200_8.42848a2c.png";